
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kbs/TkbViewAllArticlesPage/TkbViewAllArticlesPage",
      function () {
        return require("private-next-pages/kbs/TkbViewAllArticlesPage/TkbViewAllArticlesPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kbs/TkbViewAllArticlesPage/TkbViewAllArticlesPage"])
      });
    }
  